module.exports = {"TXTACL_Internet_Connection_Lost":{"id":"TXTACL_Internet_Connection_Lost","defaultMessage":"Internetverbindung getrennt"}}